import { FunnelFlowConfig, quiz, screen } from 'funnel/src/app/flow/flow-config';

export const readerFunnelFlow: FunnelFlowConfig = {
  screens: [
    quiz('wishReadAloud'),
    quiz('amountInfo'),
    quiz('audioExperienceInfo'),
    quiz('readerGoals'),
    quiz('time'),
    quiz('nonFictionInterests'),
    quiz('fictionInterests'),
    quiz('readerBooksRead'),
    quiz('readerTimeForReading'),
    quiz('readerFinishBooks'),
    quiz('readerReadingOverwhelm'),
    quiz('honest'),
    quiz('format'),
    quiz('retentionInfo'),
    quiz('technologyInfo'),
    quiz('book1'),
    quiz('book3'),
    quiz('yourBook'),
    quiz('listeningTime'),
    screen('ready'),

    quiz('prediction'),
    screen('login'),
    screen('paywall'),
  ],
};
